import { find } from "lodash"
import ModelSelector from "modules/model-selector"

interface Model {
  id: string
  name?: string
}

interface AssetAvailability {
  earliest?: string
  latest?: string
}

interface SubnavProps {
  modelId: string
  setModel: (id: string) => void
  models: Model[]
  resourceId: string | object
  resourceType: "security" | "portfolio"
  portfolioDates?: AssetAvailability
  disabled?: boolean
}

export default function Subnav({ modelId, setModel, models, resourceId, resourceType, portfolioDates, disabled }: SubnavProps) {
  const selectedModel = find(models, model => model.id === modelId)

  return <div className="research-topic-root-subnav">
    <ModelSelector
      noSpinner
      modelId={modelId}
      modelName={selectedModel ? selectedModel.name : modelId}
      setModel={setModel}
      resourceType={resourceType}
      resourceId={resourceId}
      assetAvailability={portfolioDates}
      disableUnderline
      disabled={disabled}
    />
  </div>
}
